import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { countriesDATA, planArea, logisticsData, bankData } from '@/views/examine/auditManage/request';
const state = {
  countriesData: [],
  provinceFirstLevel: [],
  bankData: [],
  logisticsData: [],
  provinceArea: [],
  provinceData: []
};
const mutations = {
  SET_COUNTRIES_DATA(state, data) {
    state.countriesData = data;
  },
  SET_PROVINCE_FIRST_LEVEL(state, data) {
    state.provinceFirstLevel = data;
  },
  SET_BANKDATA(state, data) {
    state.bankData = data;
  },
  SET_LOGISTICS_DATA(state, data) {
    state.logisticsData = data;
  },
  SET_PROVINCEAREA(state, data) {
    state.provinceArea = data;
  },
  SET_PROVINCE_DATA(state, data) {
    state.provinceData = data;
  }
};
const actions = {
  getResource({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      let resource = [countriesDATA({}), planArea({
        level: 1,
        type: 'noAll'
      }), planArea({
        level: 2,
        type: 'noAll'
      }), planArea({
        level: 3,
        type: 'noAll'
      }), bankData({
        level: 1
      }), logisticsData({
        level: 1
      })];
      const loop = data => {
        Array.isArray(data) && data.map(item => {
          item.id = item.code;
          if (item.children) {
            loop(item.children);
          }
          return item;
        });
      };
      Promise.all(resource).then(res => {
        this.countriesData = res[0] || [];
        commit('SET_COUNTRIES_DATA', res[0]);
        loop(res[1]);
        loop(res[2]);
        loop(res[3]);
        commit('SET_PROVINCE_FIRST_LEVEL', res[1]);
        commit('SET_PROVINCE_DATA', res[2]);
        commit('SET_PROVINCEAREA', res[3]);
        commit('SET_BANKDATA', res[4]);
        commit('SET_LOGISTICS_DATA', res[5]);
      });
    });
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};